import { Injectable } from '@nestjs/common';
import { PlantOperationCapacityDto } from './plant-operation-capacity.dto';
import { PlantOperationCapacity } from '../plant-operation-capacity.entity';

@Injectable()
export class PlantOperationCapacityAdapter {
    public convertDtoToEntity( PlantOperationCapacityDto:PlantOperationCapacityDto, isUpdate: boolean = false) :PlantOperationCapacity{
       const plantOperationCapacity=new PlantOperationCapacity();
       plantOperationCapacity.plantOperationId= PlantOperationCapacityDto.plantOperationId;
       plantOperationCapacity.plantId=PlantOperationCapacityDto. plantId;
       plantOperationCapacity.operationId=PlantOperationCapacityDto. operationId;
       plantOperationCapacity.mincount=PlantOperationCapacityDto.mincount;
       plantOperationCapacity.maxcount=PlantOperationCapacityDto.maxcount;
       plantOperationCapacity.isActive=PlantOperationCapacityDto==undefined?true:PlantOperationCapacityDto.isActive;
       if (isUpdate){
       plantOperationCapacity.updatedUser=PlantOperationCapacityDto.updatedUser;
       }
       else{
       plantOperationCapacity.isActive=true;
       plantOperationCapacity.createdUser=PlantOperationCapacityDto.createdUser;
       }
       return plantOperationCapacity;
       }
public convertEntityToDto( plantOperationCapacityObject:PlantOperationCapacity):PlantOperationCapacityDto{
  const plantOperationCapacityDto= new PlantOperationCapacityDto;
  plantOperationCapacityDto.plantOperationId= plantOperationCapacityObject.plantOperationId;
  plantOperationCapacityDto.plantId= plantOperationCapacityObject.plantId;
  plantOperationCapacityDto. operationId= plantOperationCapacityObject. operationId;
  plantOperationCapacityDto.mincount=plantOperationCapacityObject.mincount;
  plantOperationCapacityDto.maxcount=plantOperationCapacityObject.maxcount;
  plantOperationCapacityDto.createdUser= plantOperationCapacityObject.createdUser;
  plantOperationCapacityDto.updatedUser= plantOperationCapacityObject.updatedUser;
  plantOperationCapacityDto.versionFlag= plantOperationCapacityObject.versionFlag;
  plantOperationCapacityDto.isActive = plantOperationCapacityObject.isActive;
  plantOperationCapacityDto.updatedAt = plantOperationCapacityObject.updatedAt;
  plantOperationCapacityDto.createdAt = plantOperationCapacityObject.createdAt;

  return  plantOperationCapacityDto
}
}